<template>
  <router-view :key="this.$route.path"></router-view>
</template>

<script>
export default {
  name: 'raefton-app'
}
</script>

<style>
#app {
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?2f43f51a